import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BonusPage from './BonusPage';
import FreeSpins from '../Profile/MyBonuses/FreeSpins/FreeSpins';
import ButtonTabs from '../Common/Buttons/ButtonTabs';

const BonusOverview: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);

  return (
    <Box sx={{ paddingTop: '112px' }}>
      <Box sx={{ width: { xs: '91%', md: '875px' }, margin: 'auto', textAlign: 'center' }}>
        <Box sx={{ fontSize: '64px', lineHeight: '90px', fontWeight: 700 }}>
          {t('bonus.overview')}
        </Box>
        <Box sx={{ marginTop: '32px' }}>
          <ButtonTabs
            selected={page}
            handleChange={setPage}
            options={[{ label: t('bonus.myBonuses') }, { label: t('bonus.freeSpins') }]}
          />
        </Box>
        <Box>
          {page === 0 && <BonusPage />}
          {page === 1 && <FreeSpins />}
        </Box>
      </Box>
    </Box>
  );
};

export default BonusOverview;
